import { render, staticRenderFns } from "./PopupContainer.vue?vue&type=template&id=48024c4f&scoped=true&"
import script from "./PopupContainer.vue?vue&type=script&lang=js&"
export * from "./PopupContainer.vue?vue&type=script&lang=js&"
import style0 from "./PopupContainer.vue?vue&type=style&index=0&id=48024c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48024c4f",
  null
  
)

export default component.exports